import React, { FC, useState, useEffect } from "react";
import { InputDate } from "components-new/InputDate/InputDate";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "./ChoosingDate.module.sass";

interface ChoosingDateProps {
	title: string;
	subtitle: string;
	defaultDate: string;
	close: () => void;
	onSubmit: (date: string) => void;
	// setDate: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const ChoosingDate: FC<ChoosingDateProps> = ({ title, subtitle, defaultDate, onSubmit, close }) => {
	const [date, setDate] = useState<string>("");
	const [submitError, setSubmitError] = useState<boolean>(false);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!date || new Date(date) < new Date("2000-01-01") || new Date(date) > new Date("3000-12-31")) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			if (date !== defaultDate) {
				onSubmit(date);
			}
			close();
		}
	};

	useEffect(() => {
		if (defaultDate) setDate(defaultDate);
		//eslint-disable-next-line
	}, []);

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>{title}</h4>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<InputDate
						name={""}
						className={styles.item}
						value={date}
						onChange={(e) => setDate(e.target.value)}
						title={subtitle}
						submitError={submitError}
						required={true}
						min="2000-01-01"
						max="3000-12-31"
					/>
				</div>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отменить
					</Button>
					<Button type="submit" className={styles.button}>
						Готово
					</Button>
				</div>
			</form>
		</section>
	);
};
